<template>

    <div class="postcode-finder">
        <div class="d-flex">
            <div class="input-holder">
                <label for="postcodeFinderField">Enter postcode</label>
                <input id="postcodeFinderField" type="text" v-validate="'required|uk_postcode'" placeholder="" v-model="postcode" name="postcode" :disabled="disable"/>
                <span class="is-danger" v-if="errors.has('postcode')">{{errors.first('postcode')}}</span>
            </div>

            <div class="">
                <button buttonStyle="neutral"  @click="searchPostcode">Let's go!</button>
            </div>
        </div>  
    </div>

</template>

<script>
import axios from "axios";
import VeeValidate from 'vee-validate';
import Vue from 'vue';

VeeValidate.Validator.extend('uk_postcode', {
    getMessage: () => `Must be a valid postcode`,
    validate: value => {
        var strongRegex = new RegExp(
            "^(([gG][iI][rR] {0,}0[aA]{2})|((([a-pr-uwyzA-PR-UWYZ][a-hk-yA-HK-Y]?[0-9][0-9]?)|(([a-pr-uwyzA-PR-UWYZ][0-9][a-hjkstuwA-HJKSTUW])|([a-pr-uwyzA-PR-UWYZ][a-hk-yA-HK-Y][0-9][abehmnprv-yABEHMNPRV-Y]))) {0,}[0-9][abd-hjlnp-uw-zABD-HJLNP-UW-Z]{2}))$"
            );
        return strongRegex.test(value);
    }
});

const config = {
    errorBagName     : 'errors', // change if property conflicts.
    fieldsBagName    : 'inputs ', //Default is fields
    delay            : 0,
    locale           : 'en',
    strict           : true,
    enableAutoClasses: false,
    classNames       : {
        touched          : 'touched', // the control has been blurred
        untouched        : 'untouched', // the control hasn't been blurred
        valid            : 'valid', // model is valid
        invalid          : 'invalid', // model is invalid
        pristine         : 'pristine', // control has not been interacted with
        dirty            : 'dirty' // control has been interacted with
    },
    events           : 'input|blur',
    inject           : false
};

Vue.use(VeeValidate, config);

export default {
        props: ['callback','disable',"validation_scope"],
        inject: ['$validator'],
        components: {

        },
        data : function(){       
            return {
                postcode:'',   
                vscope:'',
                address:"",
                addresses:[],  
                axios_instance:''

            };
        },
        computed: {


            
        },
        watch:{

            address: function(){
                this.choosePostcodeAddress();
            
            }

           
        },
        created : function(){

            //new axios instance without headers to call postcode lookup API
            this.axios_instance = axios.create();
            this.axios_instance.defaults.headers.common = {};
            if(this.validation_scope)
                this.vscope = this.validation_scope+'.';

        },
        mounted : function ()
        {

        
        },
        beforeDestroy() {
        },
        methods:{

           

            /* Search Postcode function
             * Call ideal-postcode API
             * return object: addresses
            */
            searchPostcode()
            {
                this.addresses = [];
                
                if(!this.postcode)
                    return false;

                this.$validator.validate('postcode', this.postcode).then((result) => {
                    if (result){
                        this.axios_instance({
                          url: 'https://api.ideal-postcodes.co.uk/v1/postcodes/'+this.postcode+'?api_key=ak_jibicnzs55WZ9KHMifCrADasNqoID&filter=longitude,latitude',
                          method: 'get'                          
                        }).then((result) => {                            
                            this.$emit('selectpostcode',result.data.result[0].latitude, result.data.result[0].longitude);
                        }).catch((error) => {
                            if (error.response) {
                                this.errors.add({field:'postcode', msg:'Postcode not found'});
                                return false;
                            }
                        });

                    }

                    return false;
                });
            },

            choosePostcodeAddress() {
                this.callback(this.address);
            }

        }
    }
</script>

<style  scoped>
@font-face {
    font-family: 'Manrope';
    src: url('../assets/fonts/Manrope.ttf') format('truetype');
    font-style: normal;
}

    .postcode-finder {
        overflow: auto;
        
    }

    .postcode-finder label {
        display: block;
        font-family: 'Manrope';
        color: #6E7F95;
        font-size: 12px;
    }

    .postcode-finder input {
        font-family: 'Manrope';
        border: 1px solid #6E7F95;
        color: #042750;
        border-radius: 10px;
        height: 36px;
        margin: 0 15px 0 0;
        padding: 0 0 0 10px;
    }

    button, .button {
        width: 100px;
        height: 36px;
        margin-top: 26px;
        border-radius: 8px;
        padding: 5px 10px;
        cursor: pointer;
        background-color: #042750;
        color: #FFFFFF;
        text-decoration: none;
        font-size: 12px;
        outline: none;
        font-weight: 600;
        border: 0;
    }

    button:hover, .button:hover {
        opacity: .8;
    }
    


    .button-row-small {
        width: auto;
    }

    .is-danger {
        display: block;
        font-family: 'Manrope';
        color: #B91818;
        font-size: 12px;
        padding: 0;
        margin: 0;
    }

    .select-holder {
        margin-top: 20px;
        display: inline-block;
    }
</style>